export const SESSION_KEY : string = 'sportcenter-session'